import { commonAssessmentKitConstants } from "../../_constants";

let user = JSON.parse(localStorage.getItem("jigsawUser"));
const initialState = user
  ? { loggedIn: true, user, error: "" }
  : { loggedIn: false, user: {}, error: "" };

//login reducer
export const invited_assessment_kits_candidate_reducer = (state = initialState, action) => {
  switch (action.type) {
    case commonAssessmentKitConstants.INVITED_ASSESSMENT_KITS_CANDIDATE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case commonAssessmentKitConstants.INVITED_ASSESSMENT_KITS_CANDIDATE_ACTION_SUCCESS:
      return {
        invitedAssessmentData: action.payload,
      };
    case commonAssessmentKitConstants.INVITED_ASSESSMENT_KITS_CANDIDATE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};
